import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
import "./styles.css";
import _ from "lodash";

export default function Select({
  options = [], // {label: '', value: ''}
  placeholder = "Select",
  label = null,
  value = "",
  name = "select",
  onChange = () => {},
  readOnly = false,
  icon = <FaChevronDown />,
  height = "50px",
  wrapperClass = "select-wrapper",
}) {
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState(value);
  const [list, setList] = useState(options);

  const handleOnChange = (e) => {
    let filterValue = e.target?.value;
    if (filterValue) {
      let result = _.filter(options, function (b) {
        let label = _.lowerCase(b.label);
        return label.includes(_.lowerCase(filterValue));
      });
      setList(result);
      setOpen(true);
    } else {
      setList(options);
    }
    setFilter(e.target?.value);
  };

  const handleOnSelect = (obj) => {
    //call props function
    // setFilter(obj.label);
    onChange(obj);
    //set state to false
    setOpen(false);
  };

  // outside clicks
  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      /**
       * set close if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  // end: outside clicks

  useEffect(() => {
    if (value) {
      setFilter(value);
    }
  }, [value]);

  return (
    <div className="w-full">
      {label && (
        <label className="input-label-upper" htmlFor={label}>
          {label}
        </label>
      )}
      <div className={wrapperClass} ref={wrapperRef}>
        {/* <!-- component --> */}
        <div className={`relative w-full ${readOnly && "bg-lightGray"}`}>
          {/* <!-- trigger button --> */}
          <button
            type="button"
            style={{ height: height }}
            className={`select ${
              open ? "ring-lightBlue" : "ring-notification-border-gray"
            }`}
            onClick={() => {
              !readOnly && setOpen(!open);
            }}
          >
            <input
              className={`w-full mr-3 ${readOnly && "bg-lightGray"}`}
              name={name}
              autoComplete="off"
              placeholder={placeholder}
              readOnly={readOnly}
              value={filter}
              onChange={handleOnChange}
            />
            {icon}
          </button>
          {/* <!-- list items --> */}
          <ul
            className={`select-list-container select-scroll z-50 ${
              open ? "block" : "hidden"
            }`}
          >
            {_.isEmpty(list) && (
              <li className="p-2 text-center opacity-50">{`No Data Found ...`}</li>
            )}
            {(list || []).map((obj, index) => (
              <li
                key={index}
                className={`select-list ${
                  obj?.label === value && "list-active"
                }`}
                onClick={() => handleOnSelect(obj)}
              >
                {obj.label}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
